export const CAMPAIGN_SALES_CLOSED_FALLBACK =
  'Esta campanha não está recebendo participações no momento.'

export const CAMPAIGN_SALES_NOT_STARTED = 'Esta campanha ainda não começou.'

export const CAMPAIGN_SALES_WINNER_AWAIT_TITLE = 'Participações encerradas'

export const CAMPAIGN_SALES_WINNER_AWAIT_MESSAGE =
  'Esta campanha não está aceitando participações no momento. Aguarde o anúncio do vencedor.'

export type CampaignSalesWindow = {
  sales_open?: boolean | null
  sales_closed_reason?: string | null
}

export function isCampaignOpenForSales(
  campaign: CampaignSalesWindow | null | undefined
): boolean {
  return campaign?.sales_open === true
}

export function campaignSalesClosedReason(
  campaign: CampaignSalesWindow | null | undefined
): string {
  const reason = campaign?.sales_closed_reason?.trim()
  return reason && reason.length > 0 ? reason : CAMPAIGN_SALES_CLOSED_FALLBACK
}

export function shouldShowSalesClosedWinnerModal(
  campaign: CampaignSalesWindow | null | undefined
): boolean {
  if (!campaign || isCampaignOpenForSales(campaign)) {
    return false
  }

  return campaignSalesClosedReason(campaign) !== CAMPAIGN_SALES_NOT_STARTED
}

